var React = require('react');

function CircleBackground2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".5"},[React.createElement("circle",{"cx":".5","cy":"56.5","r":"56.5","fill":"#fff","key":0}),React.createElement("circle",{"cy":"56","r":"26","fill":"#FF913A","key":1})]));
}

CircleBackground2.defaultProps = {"width":"57","height":"113","fill":"none","viewBox":"0 0 57 113"};

module.exports = CircleBackground2;

CircleBackground2.default = CircleBackground2;
